import React, { useMemo } from 'react';
import { MATERIAL_STATES, MATERIAL_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';
import { Element, Handle } from 'components/Misc/Sortable';

const Material = ({ idx, material }) => {
	// Find status info
	const type = useMemo(() => MATERIAL_TYPES.find(type => type.value === material.type), [material.type]);
	const status = useMemo(() => MATERIAL_STATES.find(status => status.value === material.status), [material.status]);

	return (
		<Element index={idx} className="py-2 px-3 flex items-center space-x-2 border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
			<Handle />

			<Title
				title={material.title}
				subtitle={material.subject?.title}
				className="flex-1"
			/>

			<Show if={material.status === 'hidden'}>
				<Pill
					icon="visibility_off"
					name={status?.text}
					theme={status?.theme}
				/>
			</Show>

			<Pill
				name={type?.text}
			/>

			<Button
				small
				square
				icon="link"
				to={`/materials/${material.id}`}
			/>
		</Element>
	);
};

export default Material;